module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"unauthorized":"You don\u0027t have the permissions","unknownerror":"An unknown error occur","notfound":"Not found"},"fr":{"unauthorized":"Vous n\u0027avez pas les permissions","unknownerror":"Une erreur inconnue est survenue","notfound":"Pas trouvé"}}')
  delete Component.options._Ctor
}
